import { render, staticRenderFns } from "./NewClinicDetails.vue?vue&type=template&id=6305f743&scoped=true&"
import script from "./NewClinicDetails.vue?vue&type=script&lang=js&"
export * from "./NewClinicDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6305f743",
  null
  
)

export default component.exports